<template>
	<b-modal ref="modal" class="modal-primary" @ok="onOkModal" :title="modalTitle" :ok-title="modalOkTitle" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
		<b-form ref="form" novalidate>
			<app-mbox v-if="modalErrorMsg" :text="modalErrorMsg.message" @dismissed="clear_error_msg"></app-mbox>
			<b-form-radio-group v-model="modalItem.is_company" class="mb-3">
				<b-form-radio value="false">Fizična oseba</b-form-radio>
				<b-form-radio value="true">Podjetje</b-form-radio>
			</b-form-radio-group>
			<b-row v-if="modalItem.is_company == 'true'">
				<b-col sm="6">
					<b-form-group>
						<label for="title">Naziv</label>
						<b-form-input type="text" id="title" v-model="modalItem.title" required min="2" max="150"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6">
					<b-form-group>
						<label for="contact_name">Kontaktna oseba</label>
						<b-form-input type="text" id="contact_name" v-model="modalItem.contact_name" required min="2" max="150"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row v-else>
				<b-col sm="6">
					<b-form-group>
						<label for="first_name">Ime</label>
						<b-form-input type="text" id="first_name" v-model="modalItem.first_name" required min="2" max="150"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6">
					<b-form-group>
						<label for="last_name">Priimek</label>
						<b-form-input type="text" id="last_name" v-model="modalItem.last_name" required min="2" max="150"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-form-group>
				<label for="email">Email</label>
				<b-form-input type="email" id="email" v-model="modalItem.email" required></b-form-input>
			</b-form-group>
			<b-form-group>
				<label for="phone_number">Telefon</label>
				<b-form-input type="text" id="phone_number" v-model="modalItem.phone_number"></b-form-input>
			</b-form-group>
			<b-form-group>
				<label for="address">Naslov</label>
				<b-form-input type="text" id="address" v-model="modalItem.address"></b-form-input>
			</b-form-group>
		</b-form>
	</b-modal>
</template>
<style>
</style>
<script>
import service from '@/service';

export default {
	name: 'editkupecmodal',
	methods: {
		openModal: function () {
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			this.$refs.form.classList.add('was-validated');
			if (!this.$refs.form.checkValidity()) {
				this.modalErrorMsg = { message: 'Označena polja so nepravilno izpolnjena' };
				return;
			}
			this.modalIsBusy = true;
			this.modalErrorMsg = null;
			service.addKupec(this.modalItem)
				.then(kupec => {
					this.modalIsBusy = false;
					this.$emit('input', this.modalItem);
					if (this.modalIsNew) {
						this.$emit('kupec_add', this.modalItem);
					} else {
						this.$emit('kupec_edit', this.modalItem);
					}
					this.$refs.modal.hide();
				})
				.catch(error => {
					if (error) {
						console.log(error);
						this.modalErrorMsg = { message: 'Napaka na strežniku' };
						this.modalIsBusy = false;
					}
				});
		},
		clear_error_msg: function (event) {
			this.modalErrorMsg = null;
		}
	},
	props: ['value'],
	watch: {
		value: function () {
			if (this.value == null) {
				this.$nextTick(() => { this.$refs.form.classList.remove('was-validated'); });
				this.modalErrorMsg = null;
				this.modalIsNew = true;
				this.modalTitle = 'Dodaj kupca';
				this.modalOkTitle = 'Dodaj';
				this.modalItem.id = 0;
				this.modalItem.is_company = 'false';
				this.modalItem.title = '';
				this.modalItem.contact_name = '';
				this.modalItem.first_name = '';
				this.modalItem.last_name = '';
				this.modalItem.email = '';
				this.modalItem.phone_number = '';
				this.modalItem.address = '';
			} else {
				this.$nextTick(() => { this.$refs.form.classList.remove('was-validated'); });
				this.modalErrorMsg = null;
				this.modalIsNew = false;
				this.modalTitle = 'Uredi kupca (' + this.value.first_name + ' ' + this.value.last_name + ')';
				this.modalOkTitle = 'Shrani';
				this.modalItem.id = this.value.id;
				if (this.value.is_company) {
					this.modalItem.is_company = 'true';
				} else {
					this.modalItem.is_company = 'false';
				}
				this.modalItem.title = this.value.title;
				this.modalItem.contact_name = this.value.contact_name;
				this.modalItem.first_name = this.value.first_name;
				this.modalItem.last_name = this.value.last_name;
				this.modalItem.email = this.value.email;
				this.modalItem.phone_number = this.value.phone_number;
				this.modalItem.address = this.value.address;
			}
		}
	},
	data: function () {
		return {
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Dodaj kupca',
			modalOkTitle: 'Dodaj',
			modalCancelTitle: 'Prekliči',
			modalIsNew: true,
			modalItem: {
				id: 0,
				is_company: 'false',
				title: '',
				contact_name: '',
				first_name: '',
				last_name: '',
				email: '',
				phone_number: '',
				address: ''
			}
		};
	}
};
</script>


// WEBPACK FOOTER //
// src/components/EditKupecModal.vue